<script>
export default {
    name: 'IconClipboard',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-clipboard"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16 10v6h32v-6h4v46H12V10h4zm18 34H18v4h16v-4zm12-10H18v4h28v-4zm0-10H18v4h28v-4zM44 8v4H20V8h24z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
